import { type ISupportedLanguage } from '#app/utils/i18n.tsx'

export class StoreType {
	static readonly HEADQUARTERS = new StoreType('hq', {
		en: 'Head Office',
		it: 'Sede Centrale',
		de: 'Hauptsitz',
		fr: 'Siège Social',
		es: 'Sede Central',
	})

	static readonly SHOWROOM = new StoreType('showroom', {
		en: 'Showroom',
		it: 'Showroom',
		de: 'Showroom',
		fr: 'Showroom',
		es: 'Showroom',
	})

	static readonly STORE = new StoreType('store', {
		en: 'Store',
		it: 'Store',
		de: 'Store',
		fr: 'Magasin',
		es: 'Exposición',
	})

	static readonly GALLERY = new StoreType('gallery', {
		en: 'ICG Gallery',
		it: 'ICG Gallery',
		de: 'ICG Gallery',
		fr: 'ICG Gallery',
		es: 'ICG Gallery',
	})

	private constructor(
		public readonly code: string,
		public readonly labels: {
			en: string
			it: string
			de: string
			fr: string
			es: string
		},
	) {}

	static getAll(): StoreType[] {
		return [this.HEADQUARTERS, this.SHOWROOM, this.STORE, this.GALLERY]
	}

	static getAllCodes(): string[] {
		return this.getAll().map((category) => category.code)
	}

	static getSelectOptions(
		locale: ISupportedLanguage,
	): { value: string; label: string }[] {
		return this.getAll().map((category) => ({
			value: category.code,
			label: category.labels[locale],
		}))
	}

	static getByCode(code: string): StoreType | undefined {
		return this.getAll().find((category) => category.code === code)
	}
}
